module.exports = __webpack_public_path__ + "img/Hampa.a265621d.png";